<template>
  <v-navigation-drawer width="400" v-model="localDrawer" right temporary app>
    <v-list-item :class="localAula.color">
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium">{{
          localAula.tipo_de_aula
        }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Professor (a)</v-list-item-title>
        <p class="font-weight-light text-justify">
          {{ localAula.professor?.nome }}
        </p>
        <v-divider></v-divider>
        <v-list-item-title class="mt-4">Data</v-list-item-title>
        <p class="font-weight-light text-justify">
          {{ localAula.data_formatada }}
          {{ " - " }}
          {{ localAula.horario ? localAula.horario.descricao : localAula.dia_da_semana }}
        </p>
        <template v-if="disciplina">
          <div class="mt-4 mb-0">
            <v-list-item-title>
              <strong> Componente Curricular:</strong> {{ disciplina.descricao }}
            </v-list-item-title>
          </div>
        </template>
        <template v-else>
          <div class="mt-4 mb-5">
            <v-list-item-title>Componente(s) Curricular(es)</v-list-item-title>
          </div>

          <div class="mt-n5" v-if="localAula.is_polivalencia == 1">
            <div>
              <div v-for="(item, index) in localAula.polivalencia_formatted" :key="index">
                <pri> </pri>
                <v-card elevation="0" class="pa-1 mt-1" style="border: 1px solid #cfd8dc">
                  <div class="pa-2">
                    <span class="font-weight-bold text-uppercase">
                      {{ item.disciplina.descricao ?? "- - -" }}
                    </span>
                    <div class="mt-2">
                      <span>Conteúdo: </span>
                      <div style="border: 1px solid #cfd8dc; border-radius: 4px">
                        <span class="font-weight-light text-justify" v-if="item.conteudo">
                          <div class="mb-4 mt-2 mr-2">
                            <div
                              v-html="formatarConteudo(item.conteudo_original)"
                              class="ml-4 mb-4 mt-2 mr-2"
                            ></div>
                          </div>
                        </span>
                      </div>
                    </div>
                    <div class="mt-2">
                      <span>Horário: </span>
                      <div>
                        <span class="font-weight-light text-justify" v-if="item.conteudo">
                          <div class="ml-4 mb-4">
                            <ul v-for="(horario, index) in item.horarios" :key="index">
                              <li>{{ horario.descricao }}</li>
                            </ul>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </v-card>
              </div>
            </div>
          </div>
          <div v-if="localAula.is_polivalencia != 1">
            <p
              v-for="(disciplina, index) in localAula.disciplinas_com_descricao"
              :key="index"
              class="font-weight-light text-justify"
            >
              {{ disciplina.descricao ? disciplina.descricao : "- - -" }}
            </p>
          </div>
        </template>

        <div v-for="(item, index) of $constants.listCamposAulasLancadas" :key="index">
          <div v-if="item != 'Conteúdo polivalência'">
            <div v-if="index !== 'campos_de_experiencias'">
              <v-list-item-title v-if="localAula[index]" class="mt-4 mb-5">
                {{ item }}
              </v-list-item-title>
              <div v-if="localAula[index]" class="font-weight-light text-justify">
                <div
                  v-html="formatTexto(localAula[index]) ? formatTexto(localAula[index]) : '- - -'"
                ></div>
              </div>
            </div>
            <div v-else>
              <div v-for="(el, index) of localAula[index]" :key="index">
                <p v-if="el" :key="index" class="font-weight-light text-justify">•{{ el }}</p>
              </div>
            </div>
          </div>
        </div>
        <v-divider></v-divider>
        <!-- <v-list-item-title class="mt-4">Metodología</v-list-item-title>
        <p class="font-weight-light text-justify">
          {{ localAula.metodologia }}
        </p> -->
        <v-divider></v-divider>
        <v-list-item-title class="mt-2">Situação</v-list-item-title>
        <v-list-item-title>
          <v-chip label :color="localAula.color">
            {{ localAula.descricaoSituacao }}
          </v-chip>
        </v-list-item-title>
        <!-- <v-list-item-title class="mt-4">Motivo</v-list-item-title>
        <p class="font-weight-light">
          {{ localAula.motivo ? localAula.motivo : "Sem motivo." }}
        </p> -->
        <!-- <pre>{{ localAula }}</pre> -->

        <div v-if="localAula.e_aula_infantil" class="mt-4">
          <div
            v-for="rotina in localAula.rotinas"
            :key="rotina.id"
            class="mb-8"
            style="background-color: #f3f3f3; padding: 10px; border-radius: 4px"
          >
            <div class="text-subtitle-1 font-weight-medium mb-2">
              {{ rotina.descricao }}
            </div>

            <div v-if="rotina.experiencias_labels" class="ml-4 mb-3">
              <div class="font-weight-medium mb-1">Experiências</div>
              <ul class="mt-2 font-weight-light ml-4">
                <li v-for="(label, codigo) in rotina.experiencias_labels" :key="codigo">
                  <strong>{{ codigo }}</strong> – {{ label }}
                </li>
              </ul>
            </div>

            <div v-if="rotina.direitos_aprendizagem?.length" class="ml-4 mb-3">
              <div class="font-weight-medium mb-1">Direitos de Aprendizagem</div>
              <ul class="font-weight-light ml-4">
                <li v-for="(direito, index) in rotina.direitos_aprendizagem" :key="index">
                  {{ direito }}
                </li>
              </ul>
            </div>

            <div v-if="rotina.campos_experiencia_aula?.length" class="ml-4 mb-3">
              <div class="font-weight-medium mb-1">Campos de Experiências</div>
              <ul class="font-weight-light ml-4">
                <li v-for="(campo, index) in rotina.campos_experiencia_aula" :key="index">
                  {{ campo }}
                </li>
              </ul>
            </div>

            <div v-if="rotina.objetivos_aprendizagem" class="ml-4">
              <div class="font-weight-medium mb-1">Objetivos de Aprendizagem e Desenvolvimento</div>
              <p class="font-weight-light ml-4">
                {{ rotina.objetivos_aprendizagem }}
              </p>
            </div>

            <div v-if="rotina.orientacoes_metodologicas" class="ml-4">
              <div class="font-weight-medium mb-1">Orientações / Metodológicas</div>
              <p class="font-weight-light ml-4">
                {{ rotina.orientacoes_metodologicas }}
              </p>
            </div>

            <div v-if="rotina.recursos" class="ml-4">
              <div class="font-weight-medium mb-1">Recursos</div>
              <p class="font-weight-light ml-4">
                {{ rotina.recursos }}
              </p>
            </div>
          </div>

          <div style="background-color: #f3f3f3; padding: 10px; border-radius: 4px">
            <div class="font-weight-medium mb-1">Avaliação</div>
            <p class="font-weight-light ml-4">
              {{ localAula.avaliacao }}
            </p>
          </div>
        </div>

        <div v-else>
          <!-- Campos básicos da aula -->
          <v-list-item-title class="mt-4">Objetivo de Aprendizagem</v-list-item-title>
          <p class="font-weight-light">
            {{
              localAula.objetivo_de_aprendizagem
                ? localAula.objetivo_de_aprendizagem
                : "Sem Objetivo de Aprendizagem"
            }}
          </p>

          <v-list-item-title class="mt-4">Procedimentos Metodológicos</v-list-item-title>
          <p class="font-weight-light">
            {{
              localAula.procedimentos_metodologicos
                ? localAula.procedimentos_metodologicos
                : "Sem Procedimentos Metodológicos"
            }}
          </p>

          <v-list-item-title class="mt-4">Material de Apoio</v-list-item-title>
          <p class="font-weight-light">
            {{
              localAula.material_de_apoio ? localAula.material_de_apoio : "Sem material de Apoio"
            }}
          </p>

          <v-list-item-title class="mt-4">Avaliação da Aula</v-list-item-title>
          <p class="font-weight-light">
            {{
              localAula.avaliacao_da_aula ? localAula.avaliacao_da_aula : "Sem Avaliação da Aula"
            }}
          </p>

          <v-list-item-title class="mt-4">Unidades Temáticas</v-list-item-title>
          <div v-if="uniqueUnidadesTematicas.length > 0">
            <ul class="font-weight-light">
              <li v-for="(unidade, index) in uniqueUnidadesTematicas" :key="`ut-${index}`">
                {{ unidade }}
              </li>
            </ul>
          </div>
          <p v-else class="font-weight-light">Sem Unidades Temáticas cadastradas.</p>

          <v-list-item-title class="mt-4">Objetos de Conhecimento</v-list-item-title>
          <div v-if="uniqueObjetosConhecimento.length > 0">
            <ul class="font-weight-light">
              <li v-for="(objeto, index) in uniqueObjetosConhecimento" :key="`oc-${index}`">
                {{ objeto }}
              </li>
            </ul>
          </div>
          <p v-else class="font-weight-light">Sem Objetos de Conhecimento cadastradas.</p>

          <v-list-item-title class="mt-4">Habilidades</v-list-item-title>
          <div v-if="allHabilidades.length > 0">
            <ul class="font-weight-light">
              <li v-for="(habilidade, index) in allHabilidades" :key="`h-${index}`">
                {{ habilidade }}
              </li>
            </ul>
          </div>
          <p v-else class="font-weight-light">Sem habilidades cadastradas.</p>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-navigation-drawer>
</template>

<style setup>
.text-justify,
p,
div {
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}
</style>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    aula: {
      type: Object,
      required: true,
    },
    disciplina: {
      type: Object,
      required: false,
    },
  },
  methods: {
    formatarConteudo(conteudo) {
      if (!conteudo) return "";
      return conteudo.replace(/\n/g, "<br>");
    },
    formatTexto(texto) {
      const textoSemColchetes = texto.replace(/\[|\]/g, ""); // Remover colchetes
      const textoSemQuebraDeLinha = textoSemColchetes.replace(/\\n/g, " ").replace(/"/g, "");
      const textoFormatado = textoSemQuebraDeLinha.replace(/\n/g, "<br>"); // Substituir quebras de linha por HTML <br>
      return textoFormatado.trim() || "- - -";
    },
  },
  watch: {
    value() {
      this.localDrawer = this.value;
    },
    localDrawer() {
      this.$emit("input", this.localDrawer);
    },
  },
  computed: {
    localAula() {
      return this.aula;
    },

    parsedHabilidades() {
      try {
        if (typeof this.localAula.habilidades === "string") {
          return JSON.parse(this.localAula.habilidades);
        }
        if (Array.isArray(this.localAula.habilidades)) {
          return this.localAula.habilidades;
        }
      } catch (error) {
        this.$handleError(error);
      }
      return [];
    },

    habilidadesFormatadas() {
      if (Array.isArray(this.parsedHabilidades)) {
        return this.parsedHabilidades
          .map((h) => h.apelido)
          .filter((apelido) => apelido)
          .join(", ");
      }
      return "Sem habilidades cadastradas.";
    },

    uniqueUnidadesTematicas() {
      if (this.parsedHabilidades.length > 0) {
        const unidades = this.parsedHabilidades.map((h) => h.unidades_tematicas).filter(Boolean);
        return [...new Set(unidades)];
      }
      return [];
    },

    uniqueObjetosConhecimento() {
      if (this.parsedHabilidades.length > 0) {
        const objetos = this.parsedHabilidades.map((h) => h.objeto_conhecimento).filter(Boolean);
        return [...new Set(objetos)];
      }
      return [];
    },

    allHabilidades() {
      if (this.parsedHabilidades.length > 0) {
        return this.parsedHabilidades.map((h) => h.apelido).filter(Boolean);
      }
      return [];
    },
  },

  data() {
    return {
      localDrawer: this.value,
    };
  },
};
</script>

<style lang="scss" scoped></style>
